import React from 'react';

const WCLCLogo = ({ className = "", size = "default" }) => {
  const sizeClasses = {
    small: "h-14",
    default: "h-20",
    large: "h-28",
    custom: "",
  };

  return (
    <img 
      src="https://customer-assets.emergentagent.com/job_b1b9de1d-09f5-4842-88f6-1c07ed63b72f/artifacts/7e3djtrn_5.png"
      alt="Women's Club of Lincoln County"
      className={`${sizeClasses[size] || sizeClasses.default} w-auto object-contain ${className}`}
    />
  );
};

export default WCLCLogo;
